var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalflowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "44.7635mm",
    height: "14.1365mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 872 275",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_521870192"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M590 273c-2,0 -3,0 -3,-2l-26 -118 0 0c0,-2 1,-3 2,-3l18 0c2,0 2,1 3,3l15 83c0,0 0,0 0,0 0,0 0,0 1,0l15 -83c0,-2 1,-3 2,-3l16 0c2,0 3,1 3,3l16 83c0,0 0,0 0,0 0,0 1,0 1,0l15 -83c0,-2 1,-3 3,-3l17 1c1,0 1,0 2,0 0,1 0,2 0,2l-26 118c0,2 -1,2 -3,2l-18 0c-1,0 -2,0 -2,-2l-16 -79c0,0 0,0 0,0 0,0 0,0 -1,0l-14 79c0,2 -1,2 -3,2l-17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M513 255c5,0 9,-2 12,-5 4,-4 5,-9 5,-15l0 -47c0,-5 -1,-10 -5,-14 -3,-4 -7,-5 -12,-5 -6,0 -10,1 -13,5 -3,4 -5,9 -5,14l0 47c0,6 2,11 5,15 3,3 7,5 13,5zm0 20c-13,0 -23,-3 -30,-10 -8,-7 -11,-16 -11,-28l0 -50c0,-12 3,-21 11,-28 7,-7 17,-11 30,-11 12,0 22,4 30,11 7,7 11,16 11,28l0 50c0,12 -4,21 -11,28 -8,7 -18,10 -30,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M433 273c-1,0 -2,0 -2,-2l0 -164c0,-2 1,-3 2,-3l19 0c1,0 2,1 2,3l0 164c0,2 -1,2 -2,2l-19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M392 149c0,1 0,1 1,1l17 0c1,0 2,1 2,3l0 12c0,2 -1,2 -2,2l-17 0c-1,0 -1,1 -1,1l0 103c0,2 -1,2 -3,2l-18 0c-1,0 -2,0 -2,-2l0 -103c0,0 0,-1 -1,-1l-9 0c-2,0 -2,0 -2,-2l0 -12c0,-2 0,-3 2,-3l9 0c1,0 1,0 1,-1l0 -6c0,-14 3,-24 9,-31 6,-6 16,-9 29,-9l3 0c2,0 2,1 2,2l0 15c0,2 -1,3 -2,3l-3 0c-5,0 -9,1 -11,5 -3,3 -4,9 -4,16l0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M323 273c-2,0 -3,0 -3,-2l0 -164c0,-2 1,-3 3,-3l18 0c1,0 2,1 2,3l0 164c0,2 -1,2 -2,2l-18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M258 255c6,0 11,-2 15,-5 4,-4 6,-9 6,-15l0 -17c0,0 0,-1 -1,-1l-15 0c-6,0 -11,2 -15,6 -4,3 -6,8 -6,15 0,5 1,10 4,13 3,3 7,4 12,4zm4 -107c12,0 21,4 29,12 7,7 11,17 11,29l0 82c0,2 -1,2 -2,2l-19 0c-1,0 -2,0 -2,-2l0 -5c0,-1 0,-1 0,-1 -1,0 -1,0 -1,0 -6,7 -14,10 -25,10 -9,0 -17,-2 -24,-7 -7,-6 -11,-15 -11,-28 0,-14 4,-25 13,-31 8,-7 19,-10 33,-10l14 0c1,0 1,0 1,-1l0 -7c0,-7 -2,-12 -5,-16 -3,-4 -7,-6 -12,-6 -4,0 -8,1 -11,4 -2,2 -4,6 -4,10 0,2 -1,3 -3,3l-19 0c-2,0 -3,-1 -3,-3 1,-10 5,-18 13,-25 7,-6 16,-10 27,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M171 149c10,0 18,3 23,10 6,7 9,17 9,29l0 83c0,2 -1,2 -3,2l-18 0c-2,0 -3,0 -3,-2l0 -81c0,-7 -1,-12 -4,-16 -3,-3 -7,-5 -12,-5 -5,0 -10,2 -13,5 -2,4 -4,9 -4,16 0,1 -1,1 -1,1l0 80c0,2 -1,2 -2,2l-18 0c-2,0 -3,0 -3,-2l0 -118c0,-2 1,-3 3,-3l18 0c1,0 2,1 2,3l0 6c0,1 0,1 1,1 0,0 0,0 1,-1 6,-7 14,-10 24,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M79 273c-2,0 -2,0 -2,-2l0 -118c0,-2 0,-3 2,-3l18 0c2,0 3,1 3,3l0 118c0,2 -1,2 -3,2l-18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M35 149c0,1 1,1 1,1l17 0c2,0 3,1 3,3l0 12c0,2 -1,2 -3,2l-17 0c0,0 -1,1 -1,1l0 103c0,2 -1,2 -2,2l-18 0c-2,0 -3,0 -3,-2l0 -103c0,0 0,-1 -1,-1l-9 0c-1,0 -2,0 -2,-2l0 -12c0,-2 1,-3 2,-3l9 0c1,0 1,0 1,-1l0 -6c0,-14 3,-24 9,-31 6,-6 16,-9 29,-9l3 0c2,0 3,1 3,2l-1 15c0,2 0,3 -2,3l-2 0c-6,0 -10,1 -12,5 -2,3 -4,9 -4,16l0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4E",
    fillRule: "nonzero",
    d: "M79 139c-2,0 -2,-1 -2,-2l0 -12c0,-2 0,-3 2,-3l18 0c2,0 3,1 3,3l0 12c0,1 -1,2 -3,2l-18 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M783 0l0 90c-9,-44 -38,-75 -89,-90l89 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "744,90 744,141 694,90 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M872 0l0 90c-9,-44 -38,-75 -89,-90l89 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "833,90 833,141 783,90 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalflowLogo);
export default __webpack_public_path__ + "static/media/finalflow_logo.2188df4131b6570a0b5010225cf4a288.svg";
export { ForwardRef as ReactComponent };